import * as React from 'react'
import { Link } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useAtsEnabled } from 'modules/ats/lib/atsEnabled'
import { JOB_BOARD_INTEGRATIONS } from 'modules/billing/store/collections/subscriptionAddons'

export const useAtsInactiveWarning = (integration: string) => {
  const { atsEnabled } = useAtsEnabled()

  return !atsEnabled && JOB_BOARD_INTEGRATIONS.includes(integration)
}

export const AtsInactiveWarning = () => {
  const { navigation } = useNavigation()

  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      background="champagne400"
      paddingX="s24"
      paddingY="s16"
    >
      <Text size="300">
        {i18n.tView('app_store_v2.common.note', {
          important: (
            <Text size="300" weight="medium">
              {i18n.t('app_store_v2.common.important')}
            </Text>
          ),

          link: (
            <Link to={navigation.appStore.id.general.fullPath({ id: 'ats' })}>
              {i18n.t('app_store_v2.common.link')}
            </Link>
          ),
        })}
      </Text>
    </Box>
  )
}
